<template>
  <div class="container">
    <div class="tile">
      <div class="tile-content">
        <form class="form-horizontal" v-on:submit="save">
          <div class="form-group">
            <div class="container">
              <div class="columns">
                <div class="col-3 col-md-12">
                  <label class="form-label">{{question.text}}</label>
                </div>
                <div class="col-4 col-md-12">
                  <button  v-if="!show" @click="show = true" class="btn btn-link dateBtn">
                    <i class="fa fa-calendar" aria-hidden="true"></i>{{answer.atxt ? answer.atxt : 'Select a date'}}
                  </button>
                  <datepicker v-if="show" v-model="date" v-on:selected="selected" :inline="true"></datepicker>
                </div>
              </div>
           </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import baseQ from '@/components/questions/base'
import Datepicker from 'vuejs-datepicker'

export default {
  name: 'dateQ',
  extends: baseQ,
  components: {
    datepicker: Datepicker
  },
  data () {
    return {
      date: null,
      show: false
    }
  },
  created: function () {
    if (this.answer.atxt) {
      this.date = new Date(this.answer.atxt)
    }
  },
  methods: {
    selected: function (date) {
      this.answer.atxt = date.toDateString()
      this.show = false
      this.save()
    }
  }
}
</script>
<style scoped>
i.fa.fa-calendar {
    padding: 0 1em 0 0;
}
.btn.btn-link {
    color: #136efb!important;
}
</style>




// WEBPACK FOOTER //
// date.vue?3b19b361